import { createAction, props } from '@ngrx/store';
import { AppActions } from '../app-actions.enum';

export const loadStateFailure = createAction(
  AppActions.LOAD_STATE_FAILURE,
  props<{error: Error}>(),
);
